import React, { useRef, useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import { throttle } from 'lodash';

export default function StickyBottomHelperNew({ children }) {
    const wrapperRef = useRef();
    const contentRef = useRef();
    const [isStuck, setIsStuck] = useState(false);
    const [stickyHeight, setStickyHeight] = useState(0);
    const [bodyHeight, setBodyHeight] = useState(0);

    useEffect(() => {
        let isMounted = true;

        const handleScroll = throttle(() => {
            const bottom = wrapperRef.current.getBoundingClientRect().bottom;

            if (isMounted) {
                setIsStuck(bottom > window.innerHeight);
            }
        }, 100);

        const handleResize = throttle(() => {
            if (isMounted) {
                setBodyHeight(document.body.clientHeight);
            }
        }, 200);

        window.addEventListener('scroll', handleScroll);
        window.addEventListener('resize', handleResize);

        return () => {
            isMounted = false;
            handleScroll.cancel();
            handleResize.cancel();
            window.removeEventListener('scroll', handleScroll);
            window.removeEventListener('resize', handleResize);
        };
    }, []);

    useEffect(() => {
        setStickyHeight(contentRef.current.firstChild.offsetHeight);
        const bottom = wrapperRef.current.getBoundingClientRect().bottom;
        setIsStuck(bottom > window.innerHeight);
    }, [bodyHeight]);

    return (
        <div ref={wrapperRef}>
            <div
                ref={contentRef}
                style={{ height: stickyHeight }}
                className={cx('rec-sticky-bottom', {
                    sticky: isStuck,
                })}
            >
                {children}
            </div>
        </div>
    );
}

StickyBottomHelperNew.propTypes = {
    children: PropTypes.node,
};
